import { useState } from 'react'
import * as INPUTS from '../config/inputs'

export const useRadio = (slug, defaultOptions = {}) => {
  const { default: defaultValue, description, label, options } = INPUTS[slug]
  const [value, setValue] = useState(defaultOptions.value ?? defaultValue)

  const handleChange = value => {
    setValue(value)
  }

  const props = {
    description,
    inputRadioGroupProps: {
      format: 'inline',
      name: 'mortgagors',
      onChange: handleChange,
      options,
      valueSelected: value,
    },
    title: label,
  }

  return { inputType: 'radio', props, value }
}
